import React, { useEffect, useState } from 'react'

import { Icon, Input, INPUT_THEME, Select } from '@st-operations/uikit/src/v2/index.js'

import SignalsCollapsible from '../signals-collapsible'
import SeedsTable from './SeedsTable'

import { getSeedsEnum, getSeeds } from '_services/seeds'

import './styles.scss'

const AUDIENCE_SIZE_OPTIONS = [
  {
    value: 'accuracy',
    label: 'High Affinity',
  },
  {
    value: 'balanced',
    label: 'Balanced',
  },
  {
    value: 'reach',
    label: 'High Reach',
  },
]

const SeedsBlock = ({ audience, setAudience }) => {
  const [createdByOptions, setCreatedByOptions] = useState([])
  const [createdBy, setCreatedBy] = useState('')
  const [seedsSearch, setSeedsSearch] = useState('')

  const [selectedSeed, setSelectedSeed] = useState(audience?.seed?._id ? audience.seed : null)
  const [reloadCollapsible, setReloadCollapsible] = useState(0)

  useEffect(() => {
    getSeedsEnum().then((resp) => setCreatedByOptions(resp))
  }, [])

  useEffect(() => {
    if (selectedSeed) {
      setAudience((prev) => ({
        ...prev,
        seed: selectedSeed,
        regions: selectedSeed.regions || prev.regions,
        threshold: {
          label: prev.threshold?.label ?? AUDIENCE_SIZE_OPTIONS[1].value,
          value:
            selectedSeed?.thresholds?.[prev.threshold?.label ?? AUDIENCE_SIZE_OPTIONS[1].value]
              ?.value,
        },
        topics: [
          // define audience topics as to be the seed
          {
            atoms: { seeds: [selectedSeed.embeddingPath] },
            name: selectedSeed.name,
          },
        ],
      }))
    }
  }, [selectedSeed])

  const removeSeed = () => {
    setSelectedSeed(null)
    setAudience((prev) => ({
      ...prev,
      seed: {},
      threshold: {},
      topics: prev.topics.filter((topic) => !topic.atoms.seeds?.length),
    }))
  }

  const handleSearchSeedsInputChange = (value) => {
    setSeedsSearch(value)
  }

  const handleSelectCreatedBy = (newData) => {
    setCreatedBy(newData?.value)
  }

  const handleSelectAudienceSize = (label) => {
    const value = AUDIENCE_SIZE_OPTIONS.find((option) => option.label === label)?.value
    setAudience((prev) => ({
      ...prev,
      threshold: {
        label: value,
        value: audience.seed?.thresholds?.[value]?.value,
      },
    }))
  }

  return (
    <SignalsCollapsible
      name="URL Seeds"
      dependencies={{ audience, reloadCollapsible }}
      className="ac-seeds-block"
      resume={audience?.seed?.name}
    >
      <div className="ac-seeds-block__input-container">
        <p className="ac-seeds-block__title">Select a seed from the list below</p>
        <div className="ac-seeds-block__filters">
          <Input
            name="seeds"
            label="Search"
            placeholder="Search for url similarity seeds"
            onChange={handleSearchSeedsInputChange}
            value={seedsSearch}
            theme={INPUT_THEME.SEARCH}
          />
          <Select
            name="created_by"
            label="Created By"
            value={createdBy}
            options={createdByOptions}
            onChange={handleSelectCreatedBy}
            useReactSelect
            isClearable={true}
          />
          <Select
            name="size"
            label="Audience Size"
            value={
              AUDIENCE_SIZE_OPTIONS.find((option) => option.value === audience.threshold?.label)
                ?.label
            }
            options={AUDIENCE_SIZE_OPTIONS.map(({ label }) => label)}
            onChange={handleSelectAudienceSize}
          />
        </div>
        <If condition={selectedSeed}>
          <div className="ac-seeds-block__selected-seed">
            Selected Seed: {selectedSeed.name}
            <button className="ac-seeds-block__remove-seed" onClick={removeSeed}>
              <Icon icon="trashcan" type="outline" width={16} height={16} color="#13682b" />
            </button>
          </div>
        </If>
      </div>
      <SeedsTable
        query={seedsSearch}
        createdBy={createdBy}
        selectedSeed={selectedSeed}
        setSelectedSeed={setSelectedSeed}
        setReloadCollapsible={setReloadCollapsible}
        removeSeed={removeSeed}
        getSeeds={getSeeds}
      />
    </SignalsCollapsible>
  )
}

export default SeedsBlock
